import { GLOBAL_KEYS_PASS } from './goKeys';

/**
 * Whether a keystroke landed inside a modal dialog — a question being asked, which no key behind
 * it should act around. The dialogs marked `GLOBAL_KEYS_PASS` (the help drawer, the shortcuts
 * list) are side panels rather than questions, and do not count.
 */
export function inBlockingDialog(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  const dialog = target.closest('[role="dialog"], [role="alertdialog"]');
  return dialog !== null && !dialog.hasAttribute(GLOBAL_KEYS_PASS);
}
